"use client";
import { DateTime } from "luxon";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";
import pom from "@/utils/pom";

export interface AvailableTimeSlotsProps {
  availableTimeSlots: any[];
  selectedTime: string | null;
  // eslint-disable-next-line no-unused-vars
  handleSelectedTime: (time: string) => void;
  merchantColor: string;
}

export const AvailableTimeSlots = ({
  availableTimeSlots,
  selectedTime,
  handleSelectedTime,
  merchantColor,
}: AvailableTimeSlotsProps) => {
  const t = useTranslations("ServiceSummary");
  return (
    <>
      {availableTimeSlots && availableTimeSlots.length > 0 && (
        <div className="grid grid-cols-3 gap-4">
          {availableTimeSlots.map((timeslot: any, index: any) => {
            const formattedTime = DateTime.fromFormat(
              timeslot.startTime,
              "HH:mm"
            ).toLocaleString(DateTime.TIME_SIMPLE);

            return (
              <button
                style={
                  selectedTime === timeslot.startTime
                    ? { backgroundColor: merchantColor }
                    : {}
                }
                data-testid={applyDataTestId(pom.services.timeSlot)}
                key={index}
                className={`py-2 px-4 h-[44px] rounded-md border border-[#727272] ${
                  selectedTime === timeslot.startTime
                    ? "bg-black text-white"
                    : "bg-white text-black hover:bg-gray-300"
                } w-full text-[14px] font-medium`}
                onClick={() => handleSelectedTime(timeslot.startTime)}
              >
                {formattedTime}
              </button>
            );
          })}
        </div>
      )}
      {(!availableTimeSlots || availableTimeSlots.length <= 0) && (
        <div>
          <p className="w-full font-normal text-[16px] text-[#727272]">
            {t("noAppointmentsAvailable")}
          </p>
        </div>
      )}
    </>
  );
};
